
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/releases/20241023/ui/shared/outcomes/content-view/jst/outcome';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <a href='";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'>";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"friendly-description\">\n    <div class=\"friendly-description-title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "friendly_description_57f7fdde", "Friendly Description", options) : helperMissing.call(depth0, "t", "friendly_description_57f7fdde", "Friendly Description", options)))
    + "</div>\n    <div class=\"friendly-description-info\">";
  if (helper = helpers.friendly_description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.friendly_description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n  </div>\n";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <table class=\"criterion\">\n    <thead>\n      <tr>\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.ratings), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <th class=\"total\" aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "'>\n          <h3 class=\"total\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "total_points_44d76792", "Total Points", options) : helperMissing.call(depth0, "t", "total_points_44d76792", "Total Points", options)))
    + "</h3>\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <tr>\n        ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.ratings), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        <td class=\"total\">\n          ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points_possible), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points_possible), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_points_possible_precision_2_st': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options) : helperMissing.call(depth0, "t", "n_points_possible_precision_2_st_points_bc3748df", "%{n_points_possible_precision_2_st} Points", options)))
    + "\n        </td>\n      </tr>\n    </tbody>\n  </table>\n";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <th class=\"rating\" aria-label='";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'>\n          <h3>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h3>\n        </th>\n        ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <td class=\"rating\">\n          ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.points), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_points_precision_2_strip_insig': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "n_points_precision_2_strip_insig_points_60ad6f21", "%{n_points_precision_2_strip_insig} Points", options) : helperMissing.call(depth0, "t", "n_points_precision_2_strip_insig_points_60ad6f21", "%{n_points_precision_2_strip_insig} Points", options)))
    + "\n        </td>\n        ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <label for=\"outcome_mastery_at\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome.mastery_at_label", "Set mastery for any score at or above:", options) : helperMissing.call(depth0, "t", "outcomes.outcome.mastery_at_label", "Set mastery for any score at or above:", options)))
    + "\n    <input type=\"text\" name=\"mastery_at\" id=\"outcome_mastery_at\" value=\"60\" />\n    %\n  </label>\n";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.useForScoring), {hash:{},inverse:self.program(17, program17, data),fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program15(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <label for=\"outcome_use_for_scoring\">\n      <input type=\"checkbox\" id=\"outcome_use_for_scoring\" class=\"criterion_for_scoring\" checked />\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome.use_for_scoring", "Use this criterion for scoring", options) : helperMissing.call(depth0, "t", "outcomes.outcome.use_for_scoring", "Use this criterion for scoring", options)))
    + "\n    </label>\n  ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n     <p>";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{
    'precision': (2),
    'strip_insignificant_zeros': (true)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.mastery_points), options) : helperMissing.call(depth0, "n", (depth0 && depth0.mastery_points), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_mastery_points_precision_2_str': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "mastery_n_mastery_points_precision_2_str_points_e0ed1b3b", "Mastery: %{n_mastery_points_precision_2_str} Points", options) : helperMissing.call(depth0, "t", "mastery_n_mastery_points_precision_2_str_points_e0ed1b3b", "Mastery: %{n_mastery_points_precision_2_str} Points", options)))
    + "</p>\n    ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div id=\"calculation_method\" data-calculation-method=\"";
  if (helper = helpers.calculation_method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.calculation_method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "calculation_method_fe281f9", "Calculation Method", options) : helperMissing.call(depth0, "t", "calculation_method_fe281f9", "Calculation Method", options)))
    + ": ";
  if (helper = helpers.friendlyCalculationMethod) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.friendlyCalculationMethod); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  </div>\n\n  <div class=\"content-box\">\n    <div class=\"grid-row\">\n      <!-- Hook for OutcomeCalculationMethodFormView -->\n      <div class=\"col-xs-12 outcome-calculation-method-form\"></div>\n    </div>\n  </div>\n";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div class=\"pull-right\">\n    <button class=\"move_button ui-button ui-widget ui-state-default ui-corner-all\">\n      <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "move_abf00365", "Move", options) : helperMissing.call(depth0, "t", "move_abf00365", "Move", options)))
    + "</span>\n      <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "move_outcome_ce497e6c", "Move Outcome", options) : helperMissing.call(depth0, "t", "move_outcome_ce497e6c", "Move Outcome", options)))
    + "</span>\n    </button>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_unlink), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assessedInContext), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div id=\"assessed_info_banner\" class=\"alert alert-info outcome-assessed-info-banner \">\n        <span>\n          <span class=\"outcome-assessed-info-banner-with-mastery-scale\">\n            "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "this_outcome_has_been_used_to_assess_a_student_and_a3a48511", "This outcome has been used to assess a student and some edits will affect student results.", options) : helperMissing.call(depth0, "t", "this_outcome_has_been_used_to_assess_a_student_and_a3a48511", "This outcome has been used to assess a student and some edits will affect student results.", options)))
    + "\n          </span>\n        </span>\n      </div>\n    ";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <button class=\"edit_button ui-button ui-widget ui-state-default ui-corner-all\">\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome.links.edit_outcome", "Edit", options) : helperMissing.call(depth0, "t", "outcomes.outcome.links.edit_outcome", "Edit", options)))
    + "</span>\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "edit_outcome_867a0381", "Edit Outcome", options) : helperMissing.call(depth0, "t", "edit_outcome_867a0381", "Edit Outcome", options)))
    + "</span>\n      </button>\n    ";
  return buffer;
  }

function program28(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <button class=\"delete_button ui-button ui-widget ui-state-default ui-corner-all\"\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.assessedInContext), {hash:{},inverse:self.noop,fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n        <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "outcomes.outcome.links.delete_outcome", "Delete", options) : helperMissing.call(depth0, "t", "outcomes.outcome.links.delete_outcome", "Delete", options)))
    + "</span>\n        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.outcome")
  },data:data},helper ? helper.call(depth0, "delete_outcome_cc6546f1", "Delete Outcome", options) : helperMissing.call(depth0, "t", "delete_outcome_cc6546f1", "Delete Outcome", options)))
    + "</span>\n      </button>\n    ";
  return buffer;
  }
function program29(depth0,data) {
  
  
  return " disabled ";
  }

  buffer += "<h2 class=\"screenreader-outcome-title screenreader-only\" tabindex=\"0\">\n  ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n</h2>\n<h2 class=\"title\" role=\"presentation\">\n  <i class=\"icon-outcomes\" aria-hidden=\"true\"></i>\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.doNotRenderTitleLink), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</h2>\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.friendly_description), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n<div class=\"description user_content\">\n  ";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.setQuizMastery), {hash:{},inverse:self.program(14, program14, data),fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.hideMasteryScale), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_manage), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  